
export default {
	accessLevelIndicator: {
		width: '25px',
		height: '25px',
		borderRadius: '50%',
		display: 'inline-block',
	},
	accessLevelIndicatorViewOnly: {
		border: '1px solid #FFA21A',
		background: 'linear-gradient(180deg, #fff 0%, #fff 49%, #FFA21A 50%, #FFA21A 100%)',
	},
	accessLevelIndicatorFull: {
		border: '1px solid #4CAF50',
		backgroundColor: '#4CAF50',
	},
	accessLevel: {
		display: 'flex',
		alignItems: 'center'
	},
	accessLevelLabel: {
		marginLeft: '10px',
	},
	tr: {
		paddingLeft: '5px',
	},
	th: {
		'&:last-child': {
			maxWidth: '205px',
		},
	},
	td: {
		fontWeight: '300',
		'&:last-child': {
			maxWidth: '205px',
		},
	},
	tdBold: {
		fontWeight: '500',
	},
};